// study-program-finder.js


export default function studyProgramFinder() {

  const studyProgramFinder = document.querySelector('#study-program-finder');

  if (studyProgramFinder) {
    const studiesFilter = studyProgramFinder.querySelector('.studies-filter');
    const expandFiltersButton = studyProgramFinder.querySelector('.expand-filters');
    const selectElements = studyProgramFinder.querySelectorAll('.studies-filter select');
    const textSearchForm = studyProgramFinder.querySelector('.text-filter form');
    const textSearchInput = studyProgramFinder.querySelector('.text-filter input');
    const onlyAvailable = studyProgramFinder.querySelector('#onlyAvailable');
    const studiesFilterRadios = studyProgramFinder.querySelectorAll('.studies-filter input[type=radio]');
    const studiesList = studyProgramFinder.querySelector('.studies-list');
    const studiesItems = studyProgramFinder.querySelectorAll('.studies-list li');
    const studiesFeedback = studyProgramFinder.querySelector('.studies-feedback');
    const studiesMessage = studyProgramFinder.querySelector('.studies-message h2');
    const selectedFacetsOutput = studyProgramFinder.querySelector('.selected-facets-output');
    const clearFacetsButton = studyProgramFinder.querySelector('.clear-facets');



    /**************************************************
     * Basic, short functions
    ***************************************************/

    // Check if English page
    const isEnglish = document.body.classList.contains('en');

    // If no availability-facets present, add class to filter (to hide it)
    const availabilityFacet = studiesList.querySelector('.facet.available');
    const availabilityFilter = studiesFilter.querySelector('.availability');
    if (availabilityFacet) {
      availabilityFilter.classList.add('facet-in-use');
    }

    // Remove whitespace from studies list facets
    studiesList.querySelectorAll('.facet').forEach(facet => {
      facet.textContent = facet.textContent.trim();
    });

    // Check if small screen (based on studies-list being below filter)
    const smallScreen = studiesList.getBoundingClientRect().top > studiesFilter.getBoundingClientRect().bottom;

    // Function to scroll feedback into view
    function scrollToFeedback() {
      if (smallScreen) {
        setTimeout(() => {
          studiesFeedback.scrollIntoView({block: 'center'}); // Scroll to center if small screen
        }, 250);
      }
      else {
        studiesFeedback.scrollIntoView(); // Scroll to default top if not small screen
      }
    }

    // If text search form is submitted, scroll to feedback
    // Mostly for mobile. Submit has no actual function beside this
    textSearchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      scrollToFeedback();
    });

    // Expand-filters button, used on small screen to show/hide secondary filters
    expandFiltersButton.addEventListener('click', function() {
      this.classList.toggle('expanded');
      this.nextElementSibling.classList.toggle('expanded');
    });



    /********************************************************************
     * Feedback studies-message default state, when showing all studies
    *********************************************************************/

    let studiesMessageDefault = 'Viser alle ' + studiesItems.length + ' studietilbud';
    if (isEnglish) {
      studiesMessageDefault = 'Showing all ' + studiesItems.length + ' study programmes';
    }



    /**********************************************************************************
     * Functions to get filter parameters from url and update page filters accordingly
    ***********************************************************************************/

    // Function to parse URL parameters
    function getURLParameters() {
      const params = new URLSearchParams(window.location.search);
      const urlOutput = [];

      for (const [key, value] of params) {
        urlOutput.push(`${key}=${(value)}`);
      }
      return urlOutput;
    }

    // Function to update filters based on URL parameters
    function updateFiltersFromURL() {
      try {
        const urlParams = getURLParameters();

        // Loop through the URL parameters and update filters accordingly
        urlParams.forEach(param => {
          const [key, value] = param.split('=');

          // Filter id = key
          const filter = document.getElementById(key);

          // Get values for the different filter types
          if (filter) {

            // If filter is a text input (used for text search)
            if (filter.type === 'text') {
              filter.value = value;
            }

            // If filter is a checkbox (used for onlyAvailable studies)
            if (filter.type === 'checkbox') {
              if (value === 'yes') {
                filter.checked = true;
              }
            }

            // If filter is a list (assuming radiobuttons)
            if (filter.tagName === 'UL') {
              filter.querySelectorAll('input').forEach(radio => {

                // Find the radiobutton that matches the value
                if (radio.nextElementSibling.textContent.trim() === value) {
                  radio.checked = true;

                  // Move selected state from default/all to current element
                  filter.querySelector('.default').removeAttribute('checked');
                  filter.querySelector('.selected').classList.remove('selected');
                  radio.closest('label').classList.add('selected');
                }
              });
            }

            // If filter is a select element
            if (filter.tagName === 'SELECT') {
              // Find the option with the matching value
              const options = filter.options;
              const selectedOption = Array.from(options).find(option => option.textContent.trim() === value);
              selectedOption.selected = true;
            }
          }
        });
      }
      catch (error) {
        console.error('Studiefinner: Error updating filters from URL:', error);
      }
    }

    // Run functions to get filters from url when entering page
    updateFiltersFromURL();

    // Run updateFilters function when entering page to update filters based on url
    updateFilters(true);



    /**************************************************************************
     * When filters are manually changed by user, run updateFilters function
    ***************************************************************************/

    // Text search input
    textSearchInput.addEventListener('input', updateFilters);

    // Availability checkbox
    if (onlyAvailable) {
      onlyAvailable.addEventListener('change', updateFilters);
      onlyAvailable.addEventListener('change', scrollToFeedback);
    }

    // Radiobuttons
    studiesFilterRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        updateFilters();
        scrollToFeedback();

        // Move selected class to current parent label when checked
        radio.closest('ul').querySelectorAll('label').forEach(label => {
          label.classList.remove('selected');
        });
        radio.closest('label').classList.add('selected');
      });
    });

    // Selects
    selectElements.forEach(select => {
      select.addEventListener('change', updateFilters);
      select.addEventListener('change', scrollToFeedback);
    });


    /******************************************************
     * updateFilters function
    *******************************************************/

    function updateFilters(isTriggeredOnLoad) {

      // Clear the existing content in the selected facets output
      selectedFacetsOutput.innerHTML = '';

      // Create an array to hold the selected facets as individual spans
      const selectedFacetsSpans = [];

      // Array to hold url output
      const urlOutput = [];



      /*************************************************
       * Search text input
      **************************************************/

      const searchText = textSearchInput.value.trim().toLowerCase();
      const searchWords = searchText.split(' ');

      // Function to check if an item matches the search words
      function itemMatchesSearch(itemText, searchWords) {
        for (const word of searchWords) {
          if (!itemText.includes(word)) {
            return false;
          }
        }
        return true;
      }

      // Add the search text to facets and url output (if not empty)
      if (searchText !== '') {
        let span = document.createElement('span');
        let txt = document.createTextNode('«' + searchText + '»');
        span.append(txt);
        selectedFacetsSpans.push(span);

        urlOutput.push(`${textSearchInput.id}=${searchText}`);
      }



      /*************************************************
       * Checkbox (used for only-available studies)
      **************************************************/

      let onlyAvailableText = '';

      // Include facet text if checked
      if (onlyAvailable && onlyAvailable.checked) {
        onlyAvailableText = onlyAvailable.nextElementSibling.querySelector('strong').textContent.trim();

        let span = document.createElement('span');
        let txt = document.createTextNode(onlyAvailableText);
        span.append(txt);
        selectedFacetsSpans.push(span);

        urlOutput.push('onlyAvailable=yes');
      }



      /*************************************************
       * Radio buttons (used for topics)
      **************************************************/

      const checkedRadio = document.querySelector('.studies-filter input[type=radio]:checked');
      let checkedRadioText = '';

      // Include facet, unless it's the default option
      if (!checkedRadio.classList.contains('default')) {

        // Get container list id
        const radioListId = checkedRadio.closest('ul').id;
        // Get value (text content)
        checkedRadioText = checkedRadio.nextElementSibling.textContent.trim();

        let span = document.createElement('span');
        let txt = document.createTextNode(checkedRadioText);
        span.append(txt);
        selectedFacetsSpans.push(span);
        
        urlOutput.push(`${radioListId}=${checkedRadioText}`);
      }



      /*************************************************
       * Dropdowns (used for secondary filters)
      **************************************************/

      const selectedOptions = Array.from(selectElements).map(select => {

        // Get select id
        const selectedId = select.id;
        // Get option value
        const selectedOptionValue = select.options[select.selectedIndex].value;

        return {
          id: selectedId,
          value: selectedOptionValue
        };
      });

      selectedOptions.forEach(item => {
        if (item.value !== 'all') {
          let span = document.createElement('span');
          let txt = document.createTextNode(item.value);
          span.append(txt);
          selectedFacetsSpans.push(span);
          
          urlOutput.push(`${item.id}=${item.value}`);
        }
      });



      /************************************************
       * Update facets output and url
      *************************************************/

      // Update facets output
      for (let span of selectedFacetsSpans) {
        selectedFacetsOutput.append(span);
      }

      // Update url (when not triggered on load)
      if(typeof isTriggeredOnLoad !== "boolean" || !isTriggeredOnLoad) {
        const currentPath = window.location.pathname;
        const sanitizedUrlOutput = urlOutput.map(item => {
          const [key, value] = item.split('=');
          return `${key}=${encodeURIComponent(value)}`;
        });

        // Generate new url
        let newURL = currentPath;

        // Add "?" and sanitizedUrlOutput if not empty
        if (sanitizedUrlOutput.length > 0) {
          newURL += '?' + sanitizedUrlOutput.join('&');
        }

        // Add to page url
        history.replaceState(null, '', newURL);
      }


      /****************************************************************
       * Filter studies-items list based on selected filter facets
      *****************************************************************/

      const matchingItems = [];

      studiesItems.forEach(item => {
        const studyItemText = item.textContent.trim().toLowerCase();
        const studyItemFacets = Array.from(item.querySelectorAll('.facet'));
        const studyItemFacetTexts = studyItemFacets.map(studyItemFacet => studyItemFacet.textContent.trim());

        // Check if studies-item text matches searchWords or no searchWords
        const matchesSearchText = searchWords.length === 0 || itemMatchesSearch(studyItemText, searchWords);

        // Check if studies-item matches checkbox for only available studies, unless not selected
        const matchesOnlyAvailable = !onlyAvailableText || studyItemFacetTexts.includes(onlyAvailableText);

        // Check if studies-item matches all checked radios, unless empty (default)
        const matchesRadio = !checkedRadioText || studyItemFacetTexts.includes(checkedRadioText);

        // Check if studies-item matches all <select> options or default (all) is selected
        const matchesAllSelects = selectedOptions.every(option => {
          return option.value === 'all' || studyItemFacetTexts.includes(option.value);
        });

        // Control studies-items that meet all conditions
        if (matchesSearchText && matchesOnlyAvailable && matchesRadio && matchesAllSelects) {
          item.classList.remove('inactive');
          matchingItems.push(item);
        } else {
          item.classList.add('inactive');
        }
      });



      /**********************************************************************************
       * Update feedback studies-message based on matching facets and text search
      ***********************************************************************************/

      // If no matches
      if (matchingItems.length === 0) {
        studiesMessage.textContent = 'Fant dessverre ingen studietilbud for:';
        if (isEnglish) {
          studiesMessage.textContent = 'Sorry, found no study programmes for:';
        }
        studiesFeedback.classList.add('no-matches');
      }

      // If matches, show how many
      else {
        studiesMessage.innerHTML = 'Fant <strong>' + matchingItems.length + '</strong> studietilbud for:';
        if (isEnglish) {
          studiesMessage.innerHTML = 'Found <strong>' + matchingItems.length + '</strong> study programmes for:';
        }
        studiesFeedback.classList.remove('no-matches');
      }

      // If no selected facets
      if (selectedFacetsOutput.textContent === '') {
        studiesFeedback.classList.add('no-selected-facets');
        studiesMessage.textContent = studiesMessageDefault;
      }
      // If any selected facets or text search
      else {
        studiesFeedback.classList.remove('no-selected-facets');
      }
    }
    // end of updateFilters function



    /*********************************************************
     * Clear-facets button
    **********************************************************/

    clearFacetsButton.addEventListener('click', function () {

      // Clear the text search input
      textSearchInput.value = '';

      // Reset only-available checkbox
      if (onlyAvailable) {
        onlyAvailable.checked = false;
      }

      // Reset radio buttons to default
      const defaultRadio = document.querySelector('.studies-filter input[type=radio].default');
      defaultRadio.checked = true;

      // Reset radio parent labels
      defaultRadio.closest('ul').querySelectorAll('label').forEach(label => {
        label.classList.remove('selected')
      });
      defaultRadio.closest('label').classList.add('selected');

      // Reset select elements to default
      selectElements.forEach(select => {
        const defaultOption = select.querySelector('.default');
        if (defaultOption) {
          defaultOption.selected = true;
        }
      });

      // Manually trigger change event to update page, using first dropdown
      selectElements[0].dispatchEvent(new Event('change'));

      // Set keyboard focus
      studyProgramFinder.tabIndex = -1;
      studyProgramFinder.focus();

      // Clear the existing content in the selected facets container
      selectedFacetsOutput.innerHTML = '';

      // Set initial state on studies-feedback
      studiesMessage.textContent = studiesMessageDefault;
      studiesFeedback.classList.add('no-selected-facets');
    });
  }
}
